import {
  USERS_SUCCESS,
  UGROUP_SUCCESS,
  PERMISSIONINBATCH_SUCCESS,
  PERMISSIONINBATCH_TX_SUCCESS,
  PERMISSION_UGROUP_SUCCESS,
  PERMISSION_USER_SUCCESS,
} from "../types/index";

const userInitialState = {
  UgroupNames: {},
  Users: [],
};

const usersReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case USERS_SUCCESS:
      return action.users;
      break;
    default:
      return state;
      break;
  }
};

const ugroupInitialState = {
  UGroups: [],
};

const ugroupReducer = (state = ugroupInitialState, action) => {
  switch (action.type) {
    case UGROUP_SUCCESS:
      return action.ugroups;
      break;
    default:
      return state;
      break;
  }
};

const permissionInBatchInitialState = [];

const permissionInBatchReducer = (
  state = permissionInBatchInitialState,
  action
) => {
  switch (action.type) {
    case PERMISSIONINBATCH_SUCCESS:
      return action.permissionInBatch;
      break;
    default:
      return state;
      break;
  }
};

const permissionInBatchTXInitialState = [];

const permissionInBatchTXReducer = (
  state = permissionInBatchTXInitialState,
  action
) => {
  switch (action.type) {
    case PERMISSIONINBATCH_TX_SUCCESS:
      return action.permissionInBatchTX;
      break;
    default:
      return state;
      break;
  }
};

const permissionUgroupReducer = (state = [], action) => {
  switch (action.type) {
    case PERMISSION_UGROUP_SUCCESS:
      return action.ugroupPerms;
      break;
    default:
      return state;
      break;
  }
};

const permissionUserReducer = (state = [], action) => {
  switch (action.type) {
    case PERMISSION_USER_SUCCESS:
      return action.userPerms;
      break;
    default:
      return state;
      break;
  }
};

export default {
  usersReducer,
  ugroupReducer,
  permissionInBatchReducer,
  permissionInBatchTXReducer,
  permissionUgroupReducer,
  permissionUserReducer,
};
